import { Injectable, signal } from '@angular/core';
import { ComposerPanelTab } from '../enums/composer-panel-tab.enum';

@Injectable({ providedIn: 'root' })
export class ComposerPanelStateService {
  private readonly _activeTab = signal<ComposerPanelTab>(ComposerPanelTab.Architecture);
  readonly activeTab = this._activeTab.asReadonly();

  setTab(tab: ComposerPanelTab): void {
    this._activeTab.set(tab);
  }

  reset(): void {
    this._activeTab.set(ComposerPanelTab.Architecture);
  }
}
